const Formats = (props: any) => {

    interface LocResource {
        key: string;
        value: string;
    }

    let result: any = {};

    result.formatPrice = (amount: number, currency: string) => {
        return new Intl.NumberFormat(props.locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(amount);
    };

    result.locale = (value: string, params: any) => {
        const locResources: LocResource[] = props.locResources;
        if (locResources) {
            let rawLocResource: any;
            locResources.filter((locResource: LocResource) => {
                if (locResource.key === value) {
                    rawLocResource = locResource.value;
                }
            })
            if (rawLocResource) {
                rawLocResource = renderExpressions(rawLocResource, params);
                rawLocResource = renderIfExpressions(rawLocResource, params);
                rawLocResource = renderSubString(rawLocResource, params);
                rawLocResource = renderNumber(rawLocResource, params);
                return rawLocResource;
            }

        }
        return ""
    };

    result.formatDate = (value: Date) => {
        let locale = props.locale;
        if (locale.split("-")[0] === "no") locale = "nb-" + locale.split("-")[1];

        const newDate = new Date(value);
        const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
        // @ts-ignore
        return newDate.toLocaleDateString(locale, options).replace(/[^\x20-\x7E]| /g, '').substring(0, 10);
    };

    return result;
};

function renderNumber(rawLocResource: string, params: any) {
    let regExpr = /{([^}]*)}/g;

    let matches = rawLocResource.match(regExpr);
    if (matches !== null) {
        for (let i = 0; i < matches.length; i++) {
            let param = typeof params === 'string' ? params : params[i];
            rawLocResource = rawLocResource.replace(matches[i], param);
        }
    }
    return rawLocResource;
}

function renderExpressions(rawLocResource: string, params: any) {
    let regExpr = /(#\[[^\[\]]+])/;

    let matches = rawLocResource.match(regExpr);
    if (matches != null) {
        for (let i = 1; i < matches.length; i++) {
            let e = matches[i];
            rawLocResource = rawLocResource.replace(e, getExpressionValue(e, params));
        }
    }
    return rawLocResource;
}

function renderIfExpressions(rawLocResource: string, params: any) {
    let regExpr = /(%\[.+\/\/\/.*\/\/\/.*])/;

    let matches = rawLocResource.match(regExpr);
    if (matches != null) {
        for (let i = 1; i < matches.length; i++) {
            let e = matches[i];
            rawLocResource = rawLocResource.replace(e, getIfParamValue(e, params));
        }
    }
    return rawLocResource;
}

function renderSubString(rawLocResource: string, params: any) {
    let regExpr = /(\${[^{}]*})/g;
    let matches = rawLocResource.match(regExpr);
    if (matches != null) {
        for (let i = 0; i < matches.length; i++) {
            let e = matches[i];
            rawLocResource = rawLocResource.replace(e, getParamValue(e, params));
        }
    }

    return rawLocResource;
}

function getExpressionValue(rawLocResource: string, params: any) {
    let regExpr = /#\[([^\[\]]*)]/;

    let matches = rawLocResource.match(regExpr);

    if (matches != null) {
        let expr = matches[1];
        rawLocResource = evalExpr(expr, params)
    }

    return rawLocResource;
}

function getIfParamValue(rawLocResource: string, params: any) {
    let regExpr = /%\[(.+)\/\/\/(.*)\/\/\/(.*)]/;

    let matches = rawLocResource.match(regExpr);

    if (matches != null) {
        let condition = matches[1];
        let ifTrue = matches[2];
        let ifFalse = matches[3];

        if (evalExpr(condition, params)) {
            rawLocResource = renderSubString(ifTrue, params);
        } else {
            rawLocResource = renderSubString(ifFalse, params);
        }
    }

    return rawLocResource;
}

function evalExpr(condition: any, params: any) {
    return eval(condition)
}

function getParamValue(rawLocResource: string, params: any) {
    let regExpr = /\${([^{}]*)}/;

    let matches = rawLocResource.match(regExpr);

    if (matches != null) {
        let expr = matches[1].replace("option_", "");
        rawLocResource = params[expr]
    }

    return rawLocResource;
}

export default Formats;
